import { render, staticRenderFns } from "./Examples.vue?vue&type=template&id=48523ad6&scoped=true&"
import script from "./Examples.vue?vue&type=script&lang=js&"
export * from "./Examples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48523ad6",
  null
  
)

export default component.exports